import {BaseScenarioType, IBaseScenario} from "@/lib/types/IBaseScenario";

export interface IDesignBaseScenario extends IBaseScenario {
  scenarioType: BaseScenarioType.design,
  designScenarioType: DesignScenarioType | null,
}

export enum DesignScenarioType {
  asphalt = 'Asphalt',
  concrete = 'Concrete',
  porous = 'Porous',
  acOverlay = 'AC Overlay',
}

export enum DesignRoadwayClassification {
  parkingLotLightDuty = 'Parking Lot – Light Duty',
  parkingLotHeavyDuty = 'Parking Lot - Heavy Duty',
  residentialCollector = 'Residential/Collector',
  local = 'Local',
  arterial = 'Arterials/Highway',
  interstate = 'Interstate'
}

export enum DesignPavementType {
  newAsphalt = 'New - Asphalt',
  newConcrete = 'New - Concrete',
  acOverlayOnAsphalt = 'AC Overlay on Asphalt',
  porous = 'Porous',
  acOverlayOnConcrete = 'AC Overlay on Concrete or Composite'
}

export enum AadtLaneType {
  oneWay = 1.0,
  twoWay = 0.5
}

export enum EsalCalculationMethods {
  aadt = 'aadt',
  annual = 'annual',
  design = 'design'
}

export interface AadtCalculationInputs {
  aadt: number,
  lane_type: AadtLaneType,
  lane_type_modifier: number, // Num lanes measured
  lane_count: number,
  lane_count_modifier: number,
  traffic_count_year: number,
  traffic_growth_rate: number,
}

export interface IDesignFlexibleSubstructureLayer {
  // length: number,
  id?: number | null,
  coefficient: number,
  drainage: number,
  thickness: number,
  type: string | null,
  name: string,
  modulus: number,
  fixedThickness: boolean
}

export interface IDesignFlexibleSurfaceLayer {
  // layer_type: string,
  id?: number | null,
  coefficient: number,
  modulus: number,
  drainage: number,
  thickness: number | null,
  liftTitle: string,
}

// Used in js/lib/calculation.ts to specify output types
export interface OutputObj {
  layers: OutputObjLayer[],
  warning: string | null,
  errors: string | null
}

export interface IAashtoRigidResults {
  WPrime: number,
  D: number,
  sigma_t: number,
  log_b: number,
  sigma_l: number,
  F: number,
  TD: number,
  l: number,
  details: boolean
}

export interface IAsphaltOutputObj extends OutputObj {
  design_sn: number,
  total_sn: number,
  calculated_sn: number | null,
  target_layer_depth: number,
  layerCalculations: IAsphaltOutputObjLayerCalculations[],
  known_sn: number,
  remaining_sn: number,
  total_surface_depth: number,
}

export interface IConcreteOutputObj extends OutputObj {

  layerCalculations: IAashtoRigidResults

}

export interface OutputObjLayer {
  label: string,
  depth: number,
  type: string,
  showLayer: boolean
}

export interface IAsphaltOutputObjLayerCalculations {
  label: string,
  subgrade_mr: number | null,
  sn: number,
  sn_star: number,
  depth: number,
  depth_star: number,
  minDepth: number,
  a: number,
  prior_sn: number,
  calculated_sn: number,
  thickness_provided: boolean,
  layer_coefficient: number,
  drainage_coefficient: number,
  thickness: number,
  alternate_depth: number,
  layer_type: string,
  next_layer_type: string,
  extra_depth: number;
}

export interface SnOutput {
  alternate_depth: number,
  depth: number,
  depth_star: number,
  sn: number,
  sn_star: number,
  prior_sn: number,
  calculated_sn: number
}

export interface ILayerDef {
  unit: string,
  thickness: number | null,
  name: string,
  type: string, //'asphalt' | 'concrete' | 'porous' | 'base' | 'subgrade',
  coefficient?: number,
  modulus?: number,
  drainage?: number
}
